export default {
	sync: {
		projectDeleted: "Dieses Projekt wurde von einer anderen Person gelöscht.",
		removedFromProject: "Sie sind kein Mitglied dieses Projekts mehr.",
		processDeleted: "Dieser Prozess wurde von einer anderen Person gelöscht.",
		viewDeleted: "Diese Ansicht wurde von einer anderen Person gelöscht.",
		actionDeleted: "Diese Aktion wurde von einer anderen Person gelöscht.",
		draft: {
			changed: "Jemand anderes hat dies geändert, während Sie es bearbeitet haben.",
			changedBy: "{name} hat dies geändert, während Sie es bearbeitet haben.",
			changedByService:
				"„{name}“ (Service-Token) hat dies geändert, während Sie es bearbeitet haben.",
			deleted: "Dies wurde gelöscht, während Sie es bearbeitet haben.",
			deletedBy: "{name} hat dies gelöscht, während Sie es bearbeitet haben.",
			deletedByService:
				"„{name}“ (Service-Token) hat dies gelöscht, während Sie es bearbeitet haben.",
			keepMine: "Meine Version behalten",
			takeTheirs: "Die geänderte Version laden",
		},
	},
};
